import { useT } from "@/i18n/provider";

/**
 * While the page finds out who is signed in: the icon and a spinner, so the
 * sign-in page never flashes up for somebody who is signed in.
 */
export function Splash() {
  const t = useT();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background"
    >
      <img src="/icon-192.png" alt="" width={88} height={88} className="rounded-card" />
      <span
        aria-hidden="true"
        className="size-8 animate-spin rounded-full border-[3px] border-primary-soft border-t-primary"
      />
      <span className="sr-only">{t.loading}</span>
    </div>
  );
}
